import { PACKAGE_CONTENT_SERVICE_NAME, PackageContentServiceProvider } from './package.content.service'
import { PACKAGE_RELATED_ORDERS_SERVICE_NAME, PackageRelatedOrdersServiceProvider } from './package.relative-orders.service'
import { PACKAGE_SERVICE_NAME, PackageServiceProvider } from './package.service'

export const PACKAGE_SERVICES_MODULE_NAME = 'simax.services.package'

const module = angular.module(PACKAGE_SERVICES_MODULE_NAME, [])

module.provider(PACKAGE_CONTENT_SERVICE_NAME, PackageContentServiceProvider)
module.provider(PACKAGE_RELATED_ORDERS_SERVICE_NAME, PackageRelatedOrdersServiceProvider)
module.provider(PACKAGE_SERVICE_NAME, PackageServiceProvider)
